import type { CreateOnKeyDown } from '../../types';
import isHotkey from 'is-hotkey';
import type { HistoryPluginPropertyOptions } from './types';
import { getUndoHotkey, getRedoHotkey } from './utils';

export const onKeyDownHistory: CreateOnKeyDown<HistoryPluginPropertyOptions> =
  ({ pluginID }) =>
  (e: KeyboardEvent, { editor }) => {
    if (isHotkey(getUndoHotkey(), e)) {
      e.preventDefault();
      editor.undo();
      return true;
    }

    if (isHotkey(getRedoHotkey(), e)) {
      e.preventDefault();
      editor.redo();
      return true;
    }
  };
